import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const CalendarSettingSkeleton = memo(() => {
  return (
    <SettingCardSkeleton
      titleWidth={150}
      controls={["buttons", "buttons"]}
    />
  );
});

CalendarSettingSkeleton.displayName = "CalendarSettingSkeleton";

export default CalendarSettingSkeleton;
